import { render, staticRenderFns } from "./DoctorRegisterEditModal.vue?vue&type=template&id=318289f6&scoped=true&"
import script from "./DoctorRegisterEditModal.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterEditModal.vue?vue&type=script&lang=js&"
import style0 from "./DoctorRegisterEditModal.vue?vue&type=style&index=0&id=318289f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318289f6",
  null
  
)

export default component.exports